import { FavoriteSearch } from "@/types";

export function isActiveFavorite(
  search: string,
  currentSearch: string
): boolean {
  // Separate logic for determining if a favorite is active
  return search === currentSearch;
}

export function reorderFavorites(
  searches: FavoriteSearch[],
  dragIndex: number,
  hoverIndex: number
): FavoriteSearch[] {
  // Separate logic for reordering favorites
  const updatedSearches = [...searches];
  const [removed] = updatedSearches.splice(dragIndex, 1);
  updatedSearches.splice(hoverIndex, 0, removed);

  updatedSearches.forEach((search, index) => {
    search.favourite_order = index + 1;
  });

  return updatedSearches;
}
